module.exports = __webpack_public_path__ + "img/hr-arithmetic-combinator.35886435.png";